import rootPath, { RouteProps as BaseRouteProps } from "../routes-path";

export interface RouteProps extends BaseRouteProps {
    idParu: string;
    idZadosti?: string;
}

const path = "/pripsani-bodu-zahranicni-souteze/:idParu";

export const pathNovaZadost = rootPath + path + "/nova-zadost";
export const pathUpravitZadost = rootPath + path + "/upravit-zadost/:idZadosti";
